var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.925A2.577 2.577 0 005.925 8.5 2.577 2.577 0 008.5 11.075 2.577 2.577 0 0011.075 8.5 2.577 2.577 0 008.5 5.925zm-.196 1.811a.591.591 0 00-.586.586h-.852c.018-.799.657-1.438 1.438-1.438v.852z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.314 7.967C15.444 6.884 12.336 3.35 8.5 3.35S1.557 6.884.686 7.967a.854.854 0 000 1.066c.87 1.083 3.978 4.617 7.814 4.617s6.943-3.534 7.814-4.617a.854.854 0 000-1.066zM8.5 12.23a3.729 3.729 0 11-.001-7.457 3.729 3.729 0 01.001 7.457z"
  })));
}

export default __webpack_public_path__ + "eeec8e2b4511a43466468fa25ad4ff76.svg";
export { SvgEye as ReactComponent };